module.exports = {"540104100":"德庆镇","540104200":"塔杰乡","540104201":"章多乡","540104202":"唐嘎乡","540104203":"雪乡","540104204":"帮堆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540104.json
// module id = 2811
// module chunks = 0